import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMatchBoard from '../reducers/matchboard.reducers';
import { MatchBoardState } from '../reducers/matchboard.reducers';

const selectMatchBoardState = createFeatureSelector<MatchBoardState>('matchboard');

export const getSpotPricesSelector = createSelector(
  selectMatchBoardState,
  fromMatchBoard.getSpotPrices
);

export const getTopOrdersSelector = createSelector(
  selectMatchBoardState,
  fromMatchBoard.getTopOrders
);

export const getCurrencyMappingsSelector = createSelector(
  selectMatchBoardState,
  fromMatchBoard.getCurrencyMappings
);

export const getGraphDataSelector = createSelector(
  selectMatchBoardState,
  fromMatchBoard.getGraphData
);

export const getSwapHistorySelector = createSelector(
  selectMatchBoardState,
  fromMatchBoard.getSwapHistory
);

export const getTradesSelector = createSelector(
  selectMatchBoardState,
  fromMatchBoard.getTrades
);

export const getOrdersSelector = createSelector(
  selectMatchBoardState,
  fromMatchBoard.getOrders
);

export const getAllOrdersSelector = createSelector(
  selectMatchBoardState,
  fromMatchBoard.getAllOrders
);

export const getLastTradePricesSelector = createSelector(
  selectMatchBoardState,
  fromMatchBoard.getLastTradePrices
);

export const getCurrencyPairsSelector = createSelector(
  selectMatchBoardState,
  fromMatchBoard.getCurrencyPairs
);

export const getOnBehalfUsersSelector = createSelector(
  selectMatchBoardState,
  fromMatchBoard.getOnBehalfUsers
);

export const getSelectedOnBehalfUserSelector = createSelector(
  selectMatchBoardState,
  fromMatchBoard.getSelectedOnBehalfUser
);

export const getAbosPositions = createSelector(
  selectMatchBoardState,
  fromMatchBoard.getAbosPositions
);

export const getIsSuperUserSelector = createSelector(
  selectMatchBoardState,
  fromMatchBoard.getIsSuperUser
);


